module.exports = __webpack_public_path__ + "media/demo/image_page-2402d7aa.jpg";